import Vue from 'vue'
import VueRouter from 'vue-router'

// const originalPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push(location) {
// 	return originalPush.call(this, location).catch(err => err)
// }
Vue.use(VueRouter)

const routes = [{
	path: '/',
	name: '首页',
	component: () => import('./views/Home.vue')
},
{
	path: '/home',
	name: '首页',
	component: () => import('./views/Home.vue')
}, {
		path: '/barrageGame',
		name: '彈幕遊戲',
		component: () => import('./views/BarrageGame.vue')
	},
{
	path: '/partners',
	name:'合作廠商',
	component:() => import('./views/Partners.vue')
},
{
	path: '/gameStoreCenter',
	name: '储值中心',
	meta: {
		requireAuth: true,
	},
	component: () => import('./views/StoreCenter.vue')
},
{
	path: '/customerCenter',
	name: '客服中心',
	component: () => import('./views/CustomerCenter.vue')
},
{
	path: '/memberCenter',
	name: '会员中心',
	component: () => import('./views/MemberCenter.vue')
},
{
	path: '/memberCenter/:rid',
	name: '会员中心/id',
	component: () => import('./views/MemberCenter.vue')
}
]

const router = new VueRouter({
	routes,
	linkExactActiveClass: 'current',
	scrollBehavior(to, from, savedPosition) {
		return { x: 0, y: 0 }
	}
})

export default router
